<div *ngIf="isVisible" class="alert" [ngClass]="type">
  <img *ngIf="icon" [src]="icon" alt="{{type}} icon" class="icon">
  <div class="message">
    <ng-content></ng-content>
  </div>
  <button class="close-btn" (click)="closeAlert()">×</button>
</div>

